import { Menu, MenuItem, Paper, Popper } from "@mui/material";
import React, { SetStateAction, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Prompt } from "../../../Shared-ui/Types/common";
import { StartLoading } from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import MetaInstance from "../../../Services/AxiosInstance/MetaInstance";
import { GET_PROMPTS } from "../../../Services/Endpoint";

const options = [
  "Text shortens",
  "Rephrase",
  "What is concept?",
  "Explain",
  "Simplify",
  "Hangouts Call",
  "Text shortens",
  "Rephrase",
  "What is concept?",
  "Explain",
  "Simplify",
  "Leave Policy Hr",
];
const ITEM_HEIGHT = 48;

interface MyComponentProps {
  open: boolean;
  setOpen: React.Dispatch<SetStateAction<boolean>>;
  anchorEl: HTMLElement | null;
  scrollPercentage: number;
  prompts:Prompt[]
  handleClickPrompt:any
}

const PlaygroundMenu: React.FC<MyComponentProps> = (props) => {
  const [promptsData, setPromptsData] = useState<Prompt[]>([...props.prompts || []])




  useEffect(() => {
  }, [])
  const handleClose = () => {
    props.setOpen(!props.open);
  };

  
  return (
    <>
      {/* <Popper
        open={props.open}
        anchorEl={props.anchorEl}
        placement="bottom-start"
        modifiers={[
          {
            name: "preventOverflow",
            options: {
              boundary: "viewport", // Prevent the menu from overflowing outside the viewport
            },
          },
          // {
          //   name: "flip",
          //   options: {
          //     enabled: true, // Enable flip in case the menu would overflow on the bottom
          //   },
          // },
          {
            name: "offset",
            options: {
              offset: [35, 20], // Add space between the button and the menu
            },
          },
        ]}
        ref={popperRef} // AttachthereftothePoppercomponent
        sx={{
          // inset: props.scrollPercentage > 70 ? 'auto auto 0px 0px !important' : '0px auto auto 0px !important',
        }}
      >
        <Paper elevation={1} 
        sx={{ 
          maxHeight: "200px", 
          overflowY: "auto", 
          width: "20ch", 
          borderRadius: "10px",
        }}
        >
          <MenuItem onClick={handleClose}>Text shortens</MenuItem>
          <MenuItem onClick={handleClose}>Rephrase</MenuItem>
          <MenuItem onClick={handleClose}>What is concept?</MenuItem>
          <MenuItem onClick={handleClose}>Explain</MenuItem>
          <MenuItem onClick={handleClose}>Simplify</MenuItem>
          <MenuItem onClick={handleClose}>Hangouts Call</MenuItem>
          <MenuItem onClick={handleClose}>Option 1</MenuItem>
          <MenuItem onClick={handleClose}>Option 1</MenuItem>
          <MenuItem onClick={handleClose}>Option 1</MenuItem>
        </Paper>
      </Popper> */}
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={props.anchorEl}
        open={props.open}
        onClose={handleClose}
        slotProps={{
          paper: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: "30ch",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            },
          },
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {promptsData.map((prompt, index) => (
          <MenuItem
            key={index}
            //selected={option === 'Pyxis'}
            onClick={()=>{
              handleClose();
              props.handleClickPrompt(prompt.name)
            }}
            sx={{ fontSize: "14px", whiteSpace: "normal" }}
          >
            {prompt.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default PlaygroundMenu;
